module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-ravenna.svg?c32d3bd60c6d8ed4586e34694c47525a";